export { default as isBrowser } from './is-browser';
export { default as isOldIE } from './is-old-ie';
export { promisify } from './promise-utils';
export { uid, isPowerOfTwo, isObjectEmpty } from './utils';
export { default as log } from './log';
export { formatValue } from './format-value';
export { default as assert } from './assert';
export { stubRemovedMethods } from './stub-methods';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/utils/index.js
// module id = 25
// module chunks = 0